<template>
  <section class="app-main">
    <transition name="fade"
                mode="out-in">
      <keep-alive :include="cachedViews">
        <router-view :key="key"></router-view>
      </keep-alive>
      <!-- <router-view :key="key"></router-view> -->

    </transition>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'AppMain',
  computed: {
    key () {
      if (this.$route.meta || this.$route.meta && !this.$route.meta.cache) {
        return this.$route.name !== undefined ? this.$route.name : this.$route
      }

    },
    ...mapGetters(['cachedViews']),
  },
}
</script>
<style lang="scss">
.app-main {
  padding: 10px;
  .sky-group-form{
    .el-scrollbar__wrap {
      overflow-x: hidden;
    }
  }
  .getTitleTooltipPos {
		position: sticky;
    top: 0px;
		z-index: 2;
	}
	.getTitleTooltip {
		box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    border-radius: 4px;
    border: 1px solid #ebeef5;
    background-color: #fff;
    overflow: hidden;
    color: #303133;
		padding: 20px;
    margin-bottom: 20px;
		.errorMsgList {
			color: #f56c6c;
			padding: 5px 0;
		}
	}
	.skytech-card {
		margin-bottom: 20px;
	}
	.skytech-form-item-tip {
		color: #999999;
    font-size: 12px;
	}
}
</style>
